// @flow
import type { Coordinates } from '../../models/location'

/**
 * Returns if the distance between two places is less than 500 miles
 * @param  {Object} from Initial point information
 * @param  {float} from.lat Initial point latitude
 * @param  {float} from.lng Initial point longitude
 * @param  {Object} to Final point information
 * @param  {float} to.lat Final point latitude
 * @param  {float} to.lng Final point longitude
 * @param  {number} [limit=500] Limit distance between points
 * @return {boolean} Returns whether the distance is less than 500 miles or not
 */
export const isNearby = (
  from: Coordinates,
  to: Coordinates,
  limit: number = 500
): boolean => {
  const toRad = (number) => (number * Math.PI) / 180

  if (from.lat === to.lat && from.lng === to.lng) {
    return true
  }

  // Earth radius in miles
  const radius = 3959
  const [dLat, dLon] = [toRad(to.lat - from.lat), toRad(to.lng - from.lng)]
  const [lat1, lat2] = [toRad(from.lat), toRad(to.lat)]

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return limit > radius * c
}

export default isNearby
